/**
 * A type to be compatible with the versions of messages that have been used
 * in Nova's development. Some of these types may be deprecated in the future.
 *
 * Prefer to use MessageBundle where possible.
 */
export type CompatibleMessageBundle =
  | MessageBundle
  | {
      name: string;
      [key: string]: string;
    }
  | {
      [key: string]: string;
    };

/**
 * A type representing locally built message bundles.
 */
export interface MessageBundle {
  name: string;
  comments: string[];
  messages: Record<string, string>;
}

export function isMessageBundle(mb: CompatibleMessageBundle): mb is MessageBundle {
  return !!mb.messages;
}

export function toMessageBundle(bundle: CompatibleMessageBundle): MessageBundle {
  if (isMessageBundle(bundle)) {
    return bundle;
  }
  const { name = '', ...messages } = bundle;
  return {
    name,
    comments: [],
    messages,
  };
}
